import React from 'react';
import './Zackat.css';
import Home from '../components/Home';

function Home1() {
  return (
    <div className="Home1">
      <Home />
    </div>
  );
}

export default Home1;
